/**
 * STEP — base-currency display symbol (single source of truth).
 *
 * The tenant's display symbol comes from finance.CurrencySettings (backend).
 * It's cached here in a module variable so synchronous formatters (the many
 * `fmtMoney`/`fmt` helpers across the app) can read it without being React
 * components. `currencyStore` updates it once at startup via `setBaseSymbol`.
 *
 * Default "so'm" keeps every call site correct before the config loads and for
 * the common UZS tenant.
 */
let _symbol = "so'm";

export function setBaseSymbol(symbol: string | null | undefined): void {
  _symbol = (symbol && String(symbol).trim()) || "so'm";
}

/** Current base-currency display symbol, e.g. "so'm". */
export function baseSymbol(): string {
  return _symbol;
}
